export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'plot-analysis',
    name: '剧情解析',
    description: '深度解析蜜桃成熟时电影的完整剧情、角色关系与故事脉络',
    icon: 'ri-film-line',
  },
  {
    slug: 'cast-intro',
    name: '演员介绍',
    description: '详细介绍蜜桃成熟时主演阵容、演艺生涯与代表作品',
    icon: 'ri-user-star-line',
  },
  {
    slug: 'behind-scenes',
    name: '幕后故事',
    description: '揭秘蜜桃成熟时的拍摄花絮、制作背景与幕后趣闻',
    icon: 'ri-camera-line',
  },
  {
    slug: 'cultural-impact',
    name: '文化影响',
    description: '探讨蜜桃成熟时对香港电影文化及社会观念的深远影响',
    icon: 'ri-earth-line',
  },
  {
    slug: 'film-review',
    name: '影评推荐',
    description: '精选专业影评人与影迷对蜜桃成熟时的深度评价与推荐',
    icon: 'ri-star-line',
  },
];